import agentGetDeviceIdNameList from "@/api/device/charging-pile-manage/agentGetDeviceIdNameList";

export default {
    data: () => {
        return {
            loadingDevice: false,
            optionsDevice: [],
        }
    },
    methods: {
        remoteMethodDevice(query) {
            if (query !== '') {
                this.loading = true;
                agentGetDeviceIdNameList({"name":query}).then(res => {
                    this.optionsDevice = res.data;
                    this.loading = false;
                })
            } else {
                this.optionsDevice = [];
            }
        },
    },
}
